<template>
  <div
    role="group"
    :class="[groupSize, classes]"
  >
    <slot/>
  </div>
</template>

<script>

export default {
  name: 'VBtnGroup',
  props: {
    size: {
      type: String,
    },
    vertical: Boolean
  },
  computed: {
    groupSize() {
      return this.size ? `btn-group-${this.size}` : '';
    },
    classes () {
      return {
        'btn-group': !this.vertical,
        'btn-group-vertical': this.vertical,
      }
    },
  },
};
</script>
